import { Controller } from "@hotwired/stimulus"
import '../../_jquery';
import 'slick-carousel/slick/slick.min';
import { isBackend } from '../../utils';

export default class extends Controller {
  connect() {
    if (isBackend()) {
      this.#backendInitializer()
    } else {
      this.initialize_slick_carousel(this.element)
      this.setDecorativeLinePosition()
    }
  }

  disconnect() {
    if (this.clonedTarget) {
      this.clonedTarget.remove()
    }
  }

  initialize_slick_carousel(targetElement) {
    let $that = $(targetElement);

    $that.slick({
      arrows: true,
      nextArrow: '<button type="button" class="slick-next"></button>',
      prevArrow: '<button type="button" class="slick-prev"></button>',
      touchMove: true,
      adaptiveHeight: false,
      centerMode: true,
      centerPadding: '50px',
      slidesToShow: 3,
      speed: 1000,
      autoplay: true,
      autoplaySpeed: 5000,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            centerPadding: '1rem'
          }
        }
      ]
    });
  }

  // Questo metodo non funzionerà nell'editor Gutenberg. Non vale la pena aggiungere complessità
  // per esso.
  goToSlide(ev) {
    ev.stopPropagation()
    $(this.element).slick('slickGoTo', ev.currentTarget.dataset.slickIndex)
  }

  // Dynamic calculation of the decorative line position inside layout details
  setDecorativeLinePosition(targetElement = this.element) {
    let iconHeight, maxTitleHeight, styleSheet, titles, titlesHeights, top;
    titlesHeights = [];
    titles = $("h6", targetElement);

    titles.each(function () {
      titlesHeights.push($(this).height() * 1.5);
    });

    titlesHeights.sort(function (a, b) {
      return b - a;
    });

    maxTitleHeight = titlesHeights[0];

    titles.css('height', maxTitleHeight + 'px');

    // Than i can safely position the decorative line
    iconHeight = $("[class^=icon]", targetElement).height();
    top = $(".component-detail__expand", targetElement).offset.top - $(".component-detail__expand", targetElement).parent().offset.top + iconHeight;

    // Inject a css rule directly inside the browser stylesheet
    // because we can't easily style pseudo-elements with javascript
    styleSheet = document.styleSheets[0];
    if (styleSheet.addRule) {
      styleSheet.addRule(".layout-details:before, .layout-details:after", 'top: ' + top + 'px');
    } else if (styleSheet.insertRule) {
      styleSheet.insertRule(".layout-details:before, .layout-details:after {top: " + top + "px}", styleSheet.cssRules.length);
    } else {
      console.err('unsupported method called on styleSheet');
    }
  }

  #backendInitializer() {
    const cloneAndInsert = () => {
      this.clonedTarget = this.element.cloneNode(true)
      delete this.clonedTarget.dataset['controller']
      this.element.style.display = 'none'
      this.clonedTarget.style.display = 'block'
      this.element.parentElement.appendChild(this.clonedTarget)
    }

    cloneAndInsert()

    let observer = new window.MutationObserver(function (mutations, observer) {
      this.clonedTarget.remove()

      cloneAndInsert()

      this.initialize_slick_carousel(this.clonedTarget)
      this.setDecorativeLinePosition(this.clonedTarget)
    }.bind(this));
    observer.observe(this.element, { subtree: true, attributes: true, childList: true });

    this.initialize_slick_carousel(this.clonedTarget)
    this.setDecorativeLinePosition(this.clonedTarget)
  }
}
